import React, { useState, useRef, useCallback } from 'react';
import { Collapse } from 'react-bootstrap';
import { useToasts } from 'react-toast-notifications';
import { commentValidator } from './../../service/validatorForms';
import { createComment } from './../../service/commentService';

const CreateComment = ({userFullName, itemType, itemId}) => {
    const [showForm, setShowForm] = useState(false);
    const [description, setDescription] = useState('');
    const validatorRef = useRef(commentValidator());
    const { addToast } = useToasts();
    const [, setForceUpdate] = useState();
    const forceUpdate = useCallback(() => setForceUpdate({}), []);
    const [isLoading, setIsLoading] = useState(false);

    const submitCommentHandler = async (event) => {
        event.preventDefault();
        try {
            if (validatorRef.current.allValid()) {
                let info = {
                    itemType: itemType,
                    comment: description
                }
                itemType === 'place' ? info.placeId = itemId : info.personId = itemId;
                setIsLoading(true);
                const { status } = await createComment(info);
                if (status === 201) {
                    addToast("نظر شما ارسال شد . پس از بررسی نمایش داده خواهد شد", {
                        appearance: 'success',
                        autoDismiss: true,
                    })
                    validatorRef.current.hideMessageFor("description");
                    validatorRef.current.hideMessages();
                    setDescription("");
                    forceUpdate();
                    setShowForm(false);
                }
            }
            else {
                validatorRef.current.showMessages();
                forceUpdate();
            }
        } catch (err) {
            if (err.response && err.response.status === 404) {
                addToast("کاربر با این مشخصات وجود ندارد", {
                    appearance: 'error',
                    autoDismiss: true,
                })
            }
            else if (err.response && err.response.status === 429) {
                addToast(" نظرات تایید نشده شما به حداکثر تعداد رسیده اند ", {
                    appearance: 'warning',
                    autoDismiss: true,
                })
            }
            setDescription("");
            validatorRef.current.hideMessageFor("age");
            validatorRef.current.hideMessageFor("description");
            validatorRef.current.hideMessages();
            forceUpdate();

        }
        setIsLoading(false);
    }

    return ( 
        <div className="mt-2">
            <button className="btn btn-success py-1 px-4" 
                onClick={() => setShowForm(!showForm)}
            >
                <i className="fa fa-pencil mr-2"></i>
                ثبت نظر جدید
            </button>
            <Collapse
                in={showForm}
            >
                <div>
                    <form onSubmit={submitCommentHandler} className="pt-4">
                        <div className="col-lg-5 col-md-6 form-group">
                            <input
                                type="text"
                                id="in10"
                                className="form-control"
                                defaultValue={userFullName}
                                disabled
                                placeholder="نام و نام خانوادگی"
                            />
                            <div className="validate"></div>
                        </div>
                        <div className="col-lg-5 col-md-6 form-group">
                            <textarea
                                className="form-control"
                                rows="5"
                                placeholder="نظر خودتون رو بنویسید"
                                value={description}
                                name="description"
                                aria-describedby="description"
                                onChange={ e => setDescription(e.target.value)}
                                onBlur={() => {
                                    if (description !== '') {
                                        validatorRef.current.showMessageFor("description");
                                        forceUpdate();
                                    }
                                }}
                            ></textarea>
                                {validatorRef.current.message(
                                    "description",
                                    description,
                                    "required|min:10|max:255"
                                )}
                        </div>
                        <div className="col-lg-5 col-md-6 form-group text-center">
                            <button 
                                className="btn btn-success" 
                                type="submit"
                                disabled={isLoading}
                            >
                                <i 
                                    className={isLoading ? 'spinner-border spinner-border-sm mr-1': ''} 
                                    style={{position:'relative', bottom:'3px'}}
                                ></i> ارسال
                            </button>
                        </div>
                    </form>
                </div>
            </Collapse>
        </div>
     );
}
 
export default CreateComment;